/* eslint-disable react-hooks/exhaustive-deps */
//Core
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TagManager from "react-gtm-module";
import { actionsCard } from "../bus/card/actions";
import Helmet from "react-helmet";

import { socket } from "../REST/api";
import Canvas from "../components/Canvas";
import PreloaderComponent from "../components/PreloaderComponent";
import CookieComponent from "../components/CookieComponent";

import PopupError from "../components/_popup/PopupError";

import Header from "../components/Header";
import Footer from "../components/Footer";
import VideoReview from "../components/AboutVideo";

import { Portal } from "react-portal";
import SpeakToUs from "../components/SpeakToUs";
import bussinessPlan from "../static/bussinessPlan.jpeg";

const tagManagerArgs = {
  gtmId: "GTM-5WT3C9R",
};

const App = () => {
  const dispatch = useDispatch();
  const [preloader, setPreloader] = useState(true);
  const [cookie, setCookie] = useState(true);
  const [error, seterror] = useState(false);
  const [origin, setorigin] = useState("");
  const [preloaderdelay, setPreloaderdelay] = useState(true);

  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
    var onl = false;
    setorigin(window.location.origin);
    if (localStorage.getItem("cookies") !== null) {
      setCookie(false);
    }
    socket.on("canvasUpdated", (data) => {
      dispatch(actionsCard.setList(data.canvasData));
    });

    socket.on("connect", () => {
      onl = true;
      turnOffPreloader();
    });
    socket.on("disconnect", () => {
      seterror(true);
      console.log("disconnect");
    });
    setTimeout(() => {
      if (onl === false) {
        seterror(true);
        console.log("ONL FALSEdisconnect");

        setPreloader(false);
      }
    }, 7000);
  }, []);

  const turnOffPreloader = () => {
    const { body } = document;

    setTimeout(() => {
      setPreloader(false);
      body.setAttribute("style", "overflow-y:auto");
      setTimeout(() => {
        setPreloaderdelay(false);
      }, 1500);
    }, 1500);
  };

  const setSessionStorage = () => {
    localStorage.setItem("cookies", "true");
    setCookie(false);
  };
  return (
    <>
      <PreloaderComponent preloader={preloader} delay={preloaderdelay} />
      <Helmet
        htmlAttributes={{
          lang: "en",
        }}
        title={"Lean Canvas for Startups – Online Template (+ PDF)"}
        titleTemplate={"Lean Canvas for Startups – Online Template (+ PDF)"}
        meta={[
          {
            name: `description`,
            content:
              "Lean Canvas template helps to shape your product, plan out the perfect launch & more. It’s free to use & you can download Lean Canvas template as a PDF.",
          },
          {
            property: `og:title`,
            content: "Lean Canvas for Startups – Online Template (+ PDF)",
          },
          {
            property: `og:description`,
            content:
              "Lean Canvas template helps to shape your product, plan out the perfect launch & more. It’s free to use & you can download Lean Canvas template as a PDF.",
          },
          {
            property: `og:type`,
            content: `website`,
          },
          {
            name: `twitter:card`,
            content: `summary`,
          },
          {
            name: `twitter:creator`,
            content: "Fulcrum.Rocks",
          },
          {
            name: `twitter:title`,
            content: "Lean Canvas for Startups – Online Template (+ PDF)",
          },
          {
            name: `twitter:description`,
            content:
              "Lean Canvas template helps to shape your product, plan out the perfect launch & more. It’s free to use & you can download Lean Canvas template as a PDF.",
          },
        ].concat([
          {
            property: "og:image",
            content: bussinessPlan,
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ])}
      />
      {error && (
        <Portal>
          <PopupError />
        </Portal>
      )}
      {cookie && (
        <Portal>
          <CookieComponent setSessionStorage={setSessionStorage} />
        </Portal>
      )}
      <main style={preloader ? { opacity: 0 } : {}}>
        <Header origin={origin} />

        <Canvas />
        <VideoReview />
        <SpeakToUs />
        <Footer origin={origin} />
      </main>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-5WT3C9R"
          height="0"
          width="0"
          style="display:none;visibility:hidden"
        ></iframe>
      </noscript>
    </>
  );
};

export default App;
